import { render, staticRenderFns } from "./taskFrom.vue?vue&type=template&id=07c54412&scoped=true"
import script from "./taskFrom.vue?vue&type=script&lang=js"
export * from "./taskFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c54412",
  null
  
)

export default component.exports